import React from "react";
import { MdArrowBack, MdArrowForward, MdCheck } from "react-icons/md";

interface NavigationControlsProps {
  isFirstSection: boolean;
  isLastSection: boolean;
  isCurrentSectionComplete: boolean;
  submitting: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

const NavigationControls: React.FC<NavigationControlsProps> = ({
  isFirstSection,
  isLastSection,
  isCurrentSectionComplete,
  submitting,
  onPrevious,
  onNext,
  onSubmit
}) => {
  return (
    <div className="mt-6 md:mt-8 flex flex-wrap md:flex-nowrap gap-3 justify-between">
      <button
        onClick={onPrevious}
        disabled={isFirstSection}
        className={`flex items-center justify-center gap-1 md:gap-2 rounded-lg px-3 md:px-4 py-2 text-sm md:text-base min-w-[100px] md:min-w-[120px] ${
          isFirstSection
            ? "cursor-not-allowed bg-gray-300 text-gray-500"
            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
        }`}
      >
        <MdArrowBack className="h-4 w-4 md:h-5 md:w-5" />
        <span>Anterior</span>
      </button>
      
      {isLastSection ? (
        <button
          onClick={onSubmit}
          disabled={!isCurrentSectionComplete || submitting}
          className={`flex items-center justify-center gap-1 md:gap-2 rounded-lg px-4 md:px-6 py-2 text-sm md:text-base flex-grow md:flex-grow-0 md:min-w-[120px] ${
            !isCurrentSectionComplete || submitting
              ? "cursor-not-allowed bg-gray-300 text-gray-500"
              : "bg-brand-500 text-white hover:bg-brand-600"
          }`}
        >
          {submitting ? (
            <>
              <div className="h-4 w-4 md:h-5 md:w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
              <span>Enviando...</span>
            </>
          ) : (
            <>
              <MdCheck className="h-4 w-4 md:h-5 md:w-5" />
              <span>Finalizar</span>
            </>
          )}
        </button>
      ) : (
        <button
          onClick={onNext}
          disabled={!isCurrentSectionComplete}
          className={`flex items-center justify-center gap-1 md:gap-2 rounded-lg px-3 md:px-4 py-2 text-sm md:text-base flex-grow md:flex-grow-0 md:min-w-[120px] ${
            !isCurrentSectionComplete
              ? "cursor-not-allowed bg-gray-300 text-gray-500"
              : "bg-brand-500 text-white hover:bg-brand-600"
          }`}
        >
          <span>Siguiente</span>
          <MdArrowForward className="h-4 w-4 md:h-5 md:w-5" />
        </button>
      )}
    </div>
  );
};

export default NavigationControls; 